module.exports = __webpack_public_path__ + "img/book1.3e8b6d5e.png";